import { render } from "./fhqk.vue?vue&type=template&id=51001a90&scoped=true&ts=true"
import script from "./fhqk.vue?vue&type=script&lang=ts"
export * from "./fhqk.vue?vue&type=script&lang=ts"

import "./fhqk.vue?vue&type=style&index=0&id=51001a90&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51001a90"]])

export default __exports__